module.exports = __webpack_public_path__ + "img/Difarmer-historia-1.5e2f49cd.png";